import dictionary from '../../../../utils/dictionary'

import { SOFTWARE_MNG } from '@/api/apiModules'

export default {
  refreshInterval: false,
  viewType: 'table',
  module: SOFTWARE_MNG,
  relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入软件名',
    moreBtnWidth: 160,
    searchFieldNameArr: ['softwareName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: '同步云智助手软件',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'syncYunZhiSoftware'
      }
    ]
  },
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: '软件名',
          prop: 'softwareName',
          width: 285,
          sortField: 'softwareName'
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          return (
            <div
              class="sk-link--normal  wsp-width-100"
              on-click={$event => {
                this.$store.dispatch('ShowSoftwareDetail', row)
              }}
            >
              {value}
            </div>
          )
        }
      },
      {
        props: {
          label: '软件版本',
          prop: 'softwareVersion',
          width: 135,
          sortField: 'softwareVersion'
        }
      },
      {
        props: {
          label: '发布者',
          width: 155,
          prop: 'publisher'
        }
      },
      {
        props: {
          label: '兼容信息',
          prop: 'id',
          sortField: 'id'
        },
        dataType: 'custom',
        custom: function(data, h) {
          var html = []

          if (data.compat && data.compat.length === 0) {
            return <div>无</div>
          }
          for (const version of data.compat) {
            html.push(
              <div style="padding:1px">
                <span>
                  <el-tag type={dictionary['compatibleStatus'][version.compatibleStatus]['type']}>
                    {dictionary['compatibleStatus'][version.compatibleStatus]['label']}
                  </el-tag>
                  <span v-show={version.scheme}>【{version.scheme}】</span>
                  <span>【{version.productVersion}】及以上</span>
                </span>
              </div>
            )
          }
          return html
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          width: 160,
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          width: 160,
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '兼容性列表',
        command: 'SoftwareCompatibleProductRelation',
        name: 'SoftwareCompatibleProductRelation'
      },
      {
        icon: 'el-icon-edit',
        label: '关联用例',
        command: 'softwareRelateTestCase',
        name: 'softwareRelateTestCase'
      }
      // {
      //   icon: 'el-icon-edit',
      //   label: 'edit',
      //   command: 'SoftwareEdit',
      //   name: 'edit'
      // }
      // {
      //   icon: 'el-icon-delete',
      //   label: 'delete',
      //   command: 'SoftwareDelete',
      //   name: 'delete',
      //   confirm: {
      //     msg: 'tips.confirm.softwareMng.deleteMsg'
      //   }
      // }
    ]
  }
}
